import { render, staticRenderFns } from "./IntroductionRequestModal.vue?vue&type=template&id=4f0f4aa6&"
import script from "./IntroductionRequestModal.vue?vue&type=script&lang=js&"
export * from "./IntroductionRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports